export default {
    message_template_delete_title: "Delete Message Template",
    message_template_delete_success_message: "The message template has been deleted",
    message_template_delete_message: "Are you sure you want to delete the message template?",
    message_template_delete_general_error: "It was not possible to delete the message template due to an error",
    message_template_delete_package_in_use_unit: "The message template is linked to some units so it is not possible to delete it",
    message_template_delete_package_in_use_device_model: "The message template is linked to some device models so it is not possible to delete it",
    message_template_delete_package_in_use_unit_type: "The message template is linked to some unit types so it is not possible to delete it",
}